var _style, _rect, _path, _path2, _path3, _polygon, _polygon2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 32",
    style: {
      enableBackground: "new 0 0 27 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BABABA;}\n\t.st1{fill:#1C1C1C;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20.343,
    className: "st0",
    width: 17,
    height: 1.203
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,7.004v10.945v2.723l4.336,4.284h8.696h1.947h7.671l4.336-4.284v-2.723V7.004H0z M22.457,24.196h-7.43h-1.994 H4.53l-3.828-3.815L0.712,7.812h25.562l0.011,12.569L22.457,24.196z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.444,11.56V3.995c0-0.301,0.246-0.546,0.547-0.546h5.014c0.302,0,0.547,0.245,0.547,0.546v7.565H10.444z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.005,3.893c0.056,0,0.102,0.046,0.102,0.102v7.12h-5.218v-7.12c0-0.056,0.046-0.102,0.102-0.102H16.005  M16.005,3.004h-5.014C10.444,3.004,10,3.448,10,3.995v8.009h6.996V3.995C16.996,3.448,16.552,3.004,16.005,3.004L16.005,3.004z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15,14.004 12,14.004 11.548,12.004 15.452,12.004 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "13.996,17.004 13.5,17.427 13,17.004 13,14.004 13.996,14.004 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 0,
    className: "st3",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMachine);
export default __webpack_public_path__ + "static/media/icon-machine.40e89b3c098d3f984079c4700cfa7d6d.svg";
export { ForwardRef as ReactComponent };